import moment from 'moment';
import { useTranslationContext } from './useTranslationContext';
import { useMessageQueueContext } from './useMessageQueue';

export const useCheckShippingLimit = () => {
	const { translation } = useTranslationContext();
	const { addMessage } = useMessageQueueContext();

	const threeWeeksFromNowShippingLimit = moment().add(3, 'week').startOf('day');
	const minLimit = moment().startOf('day');

	const checkShippingLimit = (momentDeliveryDate) => {
		if (
			momentDeliveryDate &&
			momentDeliveryDate.isAfter(threeWeeksFromNowShippingLimit)
		) {
			addMessage(translation.deliveryDateExceeds3Weeks, 'error');
			return false;
		}
		return true;
	};

	return { checkShippingLimit, minLimit, threeWeeksFromNowShippingLimit };
};
